// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.RelativeDateStart
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let RelativeDateStart = /*#__PURE__*/function (RelativeDateStart) {
  RelativeDateStart[RelativeDateStart["None"] = 0] = "None";
  RelativeDateStart[RelativeDateStart["Now"] = 1] = "Now";
  RelativeDateStart[RelativeDateStart["StartOfHour"] = 2] = "StartOfHour";
  RelativeDateStart[RelativeDateStart["EndOfHour"] = 3] = "EndOfHour";
  RelativeDateStart[RelativeDateStart["StartOfDay"] = 4] = "StartOfDay";
  RelativeDateStart[RelativeDateStart["EndOfDay"] = 5] = "EndOfDay";
  RelativeDateStart[RelativeDateStart["StartOfWeek"] = 6] = "StartOfWeek";
  RelativeDateStart[RelativeDateStart["EndOfWeek"] = 7] = "EndOfWeek";
  RelativeDateStart[RelativeDateStart["StartOfMonth"] = 8] = "StartOfMonth";
  RelativeDateStart[RelativeDateStart["EndOfMonth"] = 9] = "EndOfMonth";
  RelativeDateStart[RelativeDateStart["StartOfYear"] = 10] = "StartOfYear";
  RelativeDateStart[RelativeDateStart["EndOfYear"] = 11] = "EndOfYear";
  return RelativeDateStart;
}({});
(function (_RelativeDateStart) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? RelativeDateStart[enumVal] != null ? enumVal : undefined : RelativeDateStart[enumVal];
  }
  _RelativeDateStart.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _RelativeDateStart.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _RelativeDateStart.indexOf = indexOf;
})(RelativeDateStart || (RelativeDateStart = {}));
//# sourceMappingURL=RelativeDateStart.js.map
